<template>
  <v-select
    v-model="select"
    :items="items"
    @change="setSelectStatus"
    prepend-icon="mdi-list-status"
    item-text="text"
    item-value="value"
    label="Status"
    filled
    hide-details
    solo-inverted
  ></v-select>
</template>
<script>
export default {
  name: "components-backoffice-filters_global-select-status-bet-online",
  data: () => ({
    select: {},
    items: [],
  }),
  mounted() {
    this.select = {
      text: this.$t("selectAllbetOnline"),
      value: "",
    };
    this.items = [
      {
        text: this.$t("selectAllbetOnline"),
        value: "",
      },
      {
        text: this.$t("selectPaidsbetOnline"),
        value: "1",
      },
      {
        text: this.$t("selectProcessingbetOnline"),
        value: "2",
      },
      {
        text: this.$t("finishedPlural"),
        value: "4",
      },
    ];
    this.setSelectStatus("");
  },
  computed: {},
  watch: {},
  methods: {
    setSelectStatus(value) {
      this.$store.commit("setSelectStatusBetOnline", value);
    },
  },
};
</script>
